import {UserGender} from "../../users/model/User";
import {Address} from "../../address/model/Address";
import {Borrower} from "./Borrower";

export interface Customer extends Borrower {
    firstName?: string;
    lastName?: string;
    loanNumber?: string;
    address: Address;
    funnelStatus?: string;
    fundedDate?: string;
    mortgageAdviserName?: string;
    employeeBranch?: string;
    deleted?: boolean;
    avatarUrl?: string;
    subscribedForSendgridNews?: boolean;
    isIncludedInPricingWork: boolean;
    gender?: UserGender;


}

export enum FunnelStatusEnum {
    FUNDED = "Funded",
    DOCS_BACK = "Docs Back",
    READY_FOR_SALE = "Ready For Sale",
    LOAN_SHIPPED = "Loan Shipped",
    LOAN_SOLD = "Loan Sold",
    CLEAR_TO_CLOSE = "Clear to Close",
    RECORDED = "Recorded",
    DOCS_OUT = "Docs Out",
    LOAN_CANCELED = "Loan Canceled",
    PRE_APPROVED = "Pre-approved",
    FINAL_UNDERWRITING = "Final Underwriting",
    LOAN_OPEN = "Loan Open",
    DOCS_ORDERED = "Docs Ordered",
    SOLD = "Sold",
    PRE_QUAL = "Pre-qual",
    PROCESSING = "Processing"
}